import { render, staticRenderFns } from "./ProjetosFirebase.vue?vue&type=template&id=46155d99&"
import script from "./ProjetosFirebase.vue?vue&type=script&lang=js&"
export * from "./ProjetosFirebase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports